import styled from 'styled-components';
import { DesktopFooter as _DesktopFooter } from '@/components/Footer';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0;
    width: 100vw;
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 630px minmax(0, 1fr);
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const AdHeaderActions = styled.div`
  display: flex;
  gap: 25px;
`;

export const AdViewMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-bottom: 5px;
  }
`;

export const StickyContainer = styled.div`
  position: sticky;
  top: calc(var(--header-visible-h, 0px) + 10px);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: unset;
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const DesktopFooter = styled(_DesktopFooter)`
  margin-top: 10px;
  width: 100%;
  padding: 40px calc((100% - 1000px) / 2 + 20px) 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 40px max(20px, calc((100% - 1000px) / 2 + 20px)) 15px;
  }
`;
